import { useEffect, useState } from 'react';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { Box, IconButton, MenuItem, Popover, Select, SelectChangeEvent, Tooltip } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useFilterPopover } from 'dashboard409a/hooks/useFilterPopover';
import { displayErrorMessage } from 'utilities/displayErrorMessage';
import { JobsFiltersProps } from './filters.props';

export const JobFilters = ({
  statusOptions,
  statusOptionsLoading,
  onFiltersChange,
  searchParam,
  onClearSearch,
}: JobsFiltersProps) => {
  const { handleOpen, popoverProps } = useFilterPopover({
    popoverId: 'job-filters-popover',
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
    minHeight: '80px',
  });

  const [searchStatus, setSearchStatus] = useState('default');
  const [fromValuationDate, setFromValuationDate] = useState<Date | null>(null);
  const [toValuationDate, setToValuationDate] = useState<Date | null>(null);

  useEffect(() => {
    onFiltersChange({
      searchParam,
      searchStatus,
      fromDate: fromValuationDate,
      toDate: toValuationDate
    });
  }, [searchParam, searchStatus, fromValuationDate, toValuationDate, onFiltersChange]);

  const handleSearchStatusChange = (event: SelectChangeEvent<string>) => {
    setSearchStatus(event.target.value);
  };

  const handleFromValuationDateChange = (date: Date | null) => {
    setFromValuationDate(date);
  };

  const handleToValuationDateChange = (date: Date | null) => {
    if (fromValuationDate && date && fromValuationDate > date) {
      displayErrorMessage('From Valuation Date must be before To Valuation Date');
      return;
    }
    setToValuationDate(date);
  };

  const cleanFilters = () => {
    onClearSearch?.();
    setSearchStatus('default');
    setFromValuationDate(null);
    setToValuationDate(null);
  };

  return (
    <>
      <Tooltip title="Filters" arrow>
        <IconButton onClick={handleOpen}>
          <FilterAltIcon />
        </IconButton>
      </Tooltip>
      <Popover {...popoverProps}>
        <Box display="flex" alignItems="center" gap={1} sx={{ marginTop: 2, marginLeft: 2 }}>
          <Select
            size="small"
            label="Status"
            variant="outlined"
            value={searchStatus}
            onChange={handleSearchStatusChange}
            sx={{ width: 200 }}>
            <MenuItem disabled value="default">
              Select Status
            </MenuItem>
            {statusOptionsLoading ? (
              <MenuItem disabled> Loading... </MenuItem>
            ) : (
              statusOptions.map(option => (
                <MenuItem key={option.id.option_id} value={option.title}>
                  {option.title}
                </MenuItem>
              ))
            )}
          </Select>
          <DatePicker
            label="From Valuation Date"
            value={fromValuationDate}
            onChange={handleFromValuationDateChange}
            slotProps={{
              textField: {
                variant: 'outlined',
                size: 'small',
              },
            }}
          />
          <DatePicker
            label="To Valuation Date"
            value={toValuationDate}
            onChange={handleToValuationDateChange}
            minDate={fromValuationDate || undefined}
            slotProps={{
              textField: {
                variant: 'outlined',
                size: 'small',
              },
            }}
          />
          <Tooltip title="Clear filters">
            <IconButton onClick={cleanFilters}>
              <FilterAltOffIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Popover>
    </>
  );
};